import clsx from 'clsx';
import { SvgProps } from './email';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './styles.module.css';

export function TreatmentPlanSvg({ className, ariaLabel }: SvgProps) {
  const { t } = useTranslation();

  return (
    <svg
      width="64"
      height="64"
      aria-label={ariaLabel ?? t('svg.treatmentPlan')}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(styles.brand, className)}
    >
      <path
        d="M33.5969 38.4004H39.1969V41.6004H33.5969V47.2004H30.3969V41.6004H24.7969V38.4004H30.3969V32.8004H33.5969V38.4004Z"
        fill="inherit"
      />
      <path d="M48.7969 21.6004H31.1969V18.4004H48.7969V21.6004Z" fill="inherit" />
      <path d="M26.3969 16.0004H18.3969V12.8004H26.3969V16.0004Z" fill="inherit" />
      <path d="M48.7969 16.0004H31.1969V12.8004H48.7969V16.0004Z" fill="inherit" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99688 18.4004V6.40039H55.9969V25.6004H59.1969V56.8004H4.79688V18.4004H7.99688ZM8.79688 53.5504H55.1969V28.8504H26.3969V28.8004H22.3969V22.4004H8.79688V53.5504ZM26.3969 25.6004H51.9969V10.4004H11.9969V18.4004H26.3969V25.6004Z"
        fill="inherit"
      />
    </svg>
  );
}
